import { Header } from "./Header";
import { Footer } from "./Footer";
import { WhatsAppFloat } from "./WhatsAppFloat";

export const Layout = ({ children }) => (
  <div className="min-h-screen bg-ink text-cream">
    <Header />
    <main>{children}</main>
    <Footer />
    <WhatsAppFloat />
  </div>
);
